module.exports = __webpack_public_path__ + "static/media/Sydney.3ef43ea2.png";